<div id="container-home-page">
  <div
    class="row justify-content-center align-items-center px-5 pt-5 pb-0 home-page-light-blue-bg-color">
    <div class="col-6 text-center text-black mt-4">
      <h2 class="fw-bold font-size-40">
        Deliver Exceptional Resident Experiences From the Start
      </h2>
      <p class="my-4 font-size-16">
        Provide personalized prospect experiences across the entire sales
        journey with our cutting-edge sales support tool.
      </p>
      <a
        class="btn btn-lg schedule-demo-button px-5 text-white mt-3 mb-4"
        href="https://get.tsolife.com/contact-us"
        target="_blank">
        Get Started
      </a>
    </div>
    <div class="col-7">
      <img
        class="card-img img-fluid"
        src="assets/images/sales-support-tool/sales-hero.png"
        alt="Resident Insights Hero" />
    </div>
  </div>

  <div class="row justify-content-center bg-white mt-0">
    <div class="col-6 text-center text-black mt-5">
      <h2>Redefining the Resident Sales Journey</h2>
      <p class="mt-4 font-size-17">
        Transforming the senior living sales landscape, our sales support tool
        empowers teams to create meaningful connections and deliver unparalleled
        experiences for prospective residents through personalized experiences,
        Al-driven recommendations, and insightful metrics.
      </p>
    </div>
  </div>

  <div class="card card-home-page-white px-3 py-4">
    <div class="row align-items-center invert-sm-order">
      <div class="col-md-5 offset-md-1">
        <div class="card-body mtb-50">
          <h2 class="card-title mb-4 img-info-title titles-color">
            Create Personalized Prospect Experiences
          </h2>
          <p class="card-text img-info-body">
            Utilizing data collected from prospective residents via digitized
            prospect cards, the platform orchestrates unique touchpoints that
            transform a standard communit tour into a captivating experience.
            <br />
            <br />
            Through the generation of a personalized tribune, activity calendar,
            digital welcome signage, and resident friend-matching
            recommendations, prospective residents develop a sense of belonging
            even before they move in.
          </p>
        </div>
      </div>

      <div class="col-md-5">
        <img
          class="card-img img-fluid"
          src="assets/images/sales-support-tool/personalized-prospect-experience.png"
          alt="TSOLife Calendar" />
      </div>
    </div>
  </div>

  <!------>

  <div class="card card-home-page-white px-3 py-4">
    <div class="row">
      <div class="offset-md-1 col-md-5">
        <div class="card-body">
          <img
            class="card-img img-fluid"
            src="assets/images/sales-support-tool/craft-strategic-outreach.png"
            alt="TSOLife Calendar" />
        </div>
      </div>

      <div class="col-md-5 d-flex align-items-center">
        <div class="card-body">
          <h2 class="card-title mb-4 img-info-title titles-color">
            Craft Strategic Outreach with Intelligent Guidance
          </h2>
          <p class="card-text img-info-body">
            Harnessing the capabilities of Al, the platform produces automated,
            personalized video recommendations tailored to the prospect's
            interests and stage in the sales funnel.
            <br />
            <br />
            With distinctive features such as recommended video types and
            scripts, users can seamlessly integrate customized videos into their
            outreach efforts, enhancing the overall experience for prospective
            residents.
          </p>
        </div>
      </div>
    </div>
  </div>

  <!------>

  <div class="card card-home-page-white px-3 py-4">
    <div class="row align-items-center invert-sm-order">
      <div class="col-md-5 offset-md-1">
        <div class="card-body mtb-50">
          <h2 class="card-title mb-4 img-info-title titles-color">
            Unlock Essential Metrics for Sales Enhancement
          </h2>
          <p class="card-text img-info-body">
            Utilizing the platform's comprehensive sales dashboard, users can
            access essential metrics for optimizing their sales strategy.
            <br />
            <br />
            These metrics include deal stage metrics, video engagement, and
            prospect tour calendars, providing sales teams with valuable
            insights that can be transformed into unparalleled experiences for
            prospective residents.
          </p>
        </div>
      </div>

      <div class="col-md-5">
        <img
          class="card-img img-fluid"
          src="assets/images/sales-support-tool/unlock-essential-metrics.png"
          alt="TSOLife Calendar" />
      </div>
    </div>
  </div>

  <div class="row justify-content-center p-5 text-white schedule-demo-bg-color">
    <div class="col-5 my-4">
      <h2 class="text-center">Ready to get started ?</h2>
      <p class="text-center mt-4 font-size-20">
        Get a firsthand look at how our platform is enabling operators to
        deliver exceptional resident experiences and thrive in an ever-evolving
        industry landscape.
      </p>
      <div class="d-flex justify-content-center mt-4">
        <a
          class="btn btn-lg btn-outline-light mx-auto"
          href="https://calendly.com/tsolife-david-sawyer/60min"
          target="_blank">
          Schedule Demo
        </a>
      </div>
    </div>
  </div>
</div>
